<template>
  <div class="step-finish">
    <h2 class="title">Finalizar consulta</h2>
    <p class="description">Antes de finalizar a consulta é importante verificar se os dados estão corretos.</p>

    <div class="fields">
      <confirmation-field
        :label="tagFieldLabel"
        :value="form[tagFieldName]"
        v-if="hasTagField"
      />

      <confirmation-field
        label="Identificador da Consulta"
        :value="form.id"
      />

      <confirmation-field
        v-for="field in sharedFields"
        :key="field.name"
        :label="field.label"
        :value="form[field.name]"
        :options="field.values"
      />
    </div>

    <div
      class="group-fields"
      v-for="group in exclusiveFieldsGrouped"
      :key="group.name"
    >
      <div class="groupTitle">{{ group.label }}</div>

      <div class="fields">
        <confirmation-field
          v-for="field in group.fields"
          :key="field.name"
          :label="field.label"
          :value="form[`${field.name}${(group.id ? `#${group.id}` : '')}`]"
          :options="field.values"
        />
      </div>
    </div>
  </div>
</template>

<script>
import newQueryFormFields from '@/compliance/mixins/newQueryFormFields';
import newQueryTagFields from '@/compliance/mixins/newQueryTagField';
import ConfirmationField from '@/compliance/components/new-query/step-finish/ConfirmationField.vue';
import { mapState } from 'vuex';

export default {
  name: 'StepFinish',

  props: {
    tag: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  computed: {
    ...mapState('template', {
      template: 'template',
    }),
  },

  mixins: [
    newQueryFormFields,
    newQueryTagFields,
  ],

  components: {
    ConfirmationField,
  },
};
</script>

<style lang="scss" scoped>
  .step-finish {
    > .title {
      @apply text-3xl;
      @apply text-center;
    }

    > .description {
      @apply pb-4;
      @apply text-sm;
      @apply text-center;
    }

    > .fields,
    > .groupFields > .fields {
      @apply border-opacity-50;
      @apply border-t-2;
      @apply border-gray-100;
    }
  }
</style>
